import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import SupplierGroupService from "services/Setup/Supplier/SupplierGroupService";
import { notification } from "antd";

export const initialState = {
  loading: false,
  message: "",
  showMessage: false,
  redirect: "",
  supplierGroupSliceList: [
    { id: "0", supplierGroupSliceId: "0", supplierGroupSliceName: "No Data" },
  ],
  response: {},
  subSupplerGroupList: [],
};

export const addtSupplerGroup = createAsyncThunk(
  "supplierGroupSlice/addtSupplerGroup",
  async () => {
    console.log("🚀 ~ responseaddtSupplerGroup:");
    const response = await SupplierGroupService.getSupplierGroup();
    console.log("🚀 ~ responseaddtSupplerGroup:", response);
    if (response) {
      return response.data;
    } else {
      console.log("errorresponseaddtSupplerGroup");
      return { data: "None" };
    }
  }
);

export const getSupplerGroup = createAsyncThunk(
  "supplierGroupSlice/getSupplerGroup",
  async () => {
    console.log("🚀 ~ responsegetSupplerGroup:");
    const response = await SupplierGroupService.getSupplierGroup();
    console.log("🚀 ~ responsegetSupplerGroup:", response);
    if (response) {
      return response.data;
    } else {
      console.log("errorresponsegetSupplerGroup");
      return { data: "None" };
    }
  }
);

export const getSupplerGroupItem = createAsyncThunk(
  "supplierGroupSlice/getSupplerGroupItem",
  async (data, { rejectWithValue }) => {
    console.log("🚀 ~ responsegetSupplerGroupItem:");
    const response = await SupplierGroupService.getSupplerGroupItem(data);
    console.log("🚀 ~ responsegetSupplerGroupItem:", response);
    if (response) {
      return response.data;
    } else {
      console.log("errorresponsegetSupplerGroupApproval");
      return { data: "None" };
    }
  }
);

export const getSupplerGroupItemSerch = createAsyncThunk(
  "supplierGroupSlice/getSupplerGroupItemSerch",
  async (data, { rejectWithValue }) => {
    console.log("🚀 ~ responsegetSupplerGroupItemSerch:");
    const response = await SupplierGroupService.getSupplerGroupItemSerch(data);
    console.log("🚀 ~ responsegetSupplerGroupItemSerch:", response);
    if (response) {
      return response.data;
    } else {
      console.log("errorresponsegetSupplerGroupApproval");
      return { data: "None" };
    }
  }
);
export const getSupplerGroupApproval = createAsyncThunk(
  "supplierGroupSlice/getSupplerGroupApproval",
  async (data, { rejectWithValue }) => {
    console.log("🚀 ~ responsegetSupplerGroupApproval:");
    const response = await SupplierGroupService.getSupplerGroupApproval(data);
    console.log("🚀 ~ responsegetSupplerGroupApproval:", response);
    if (response) {
      return response.data;
    } else {
      console.log("errorresponsegetSupplerGroupApproval");
      return { data: "None" };
    }
  }
);

export const deleteSupplierGroup = createAsyncThunk(
  "supplierGroupSlice/deleteSupplierGroup",
  async (data, { rejectWithValue }) => {
    console.log("🚀 ~ responsedeleteSupplierGroup:");
    const response = await SupplierGroupService.deleteSupplierGroup(data);
    console.log("🚀 ~ responsedeleteSupplierGroup:", response);
    if (response) {
      return response.data;
    } else {
      console.log("errorresponsedeleteSupplierGroup");
      return { data: "None" };
    }
  }
);

export const addSupplierGroup = createAsyncThunk(
  "supplierGroupSlice/addSupplierGroup",
  async (data, { rejectWithValue }) => {
    console.log("🚀 ~ addSupplierGroupdata:", data);
    try {
      const response = await SupplierGroupService.addSupplierGroup(data);
      console.log("🚀 ~ response:", response);

      if (response.status === 200) {
        notification.success({
          message: response.data.status,
          description: response.data.message,
          duration: 3,
        });
        return response;
      } else {
        //Selain Response 200
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ postProductCollection error:", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const supplierGroupReturn = createAsyncThunk(
  "supplierGroupSlice/supplierGroupReturn",
  async (data, { rejectWithValue }) => {
    console.log("🚀 ~ supplierGroupReturndata:", data);
    try {
      const response = await SupplierGroupService.supplierGroupReturn(data);
      console.log("supplierGroupReturn", response);
      if (response.status === 200) {
        notification.success({
          message: response.data.status,
          description: response.data.message,
          duration: 3,
        });
        return response;
      } else {
        //Selain Response 200
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const supplierGroupApproval = createAsyncThunk(
  "supplierGroupSlice/supplierGroupApproval",
  async (data, { rejectWithValue }) => {
    console.log("🚀 ~ supplierGroupApprovaldata:", data);
    try {
      const response = await SupplierGroupService.supplierGroupApproval(data);
      console.log("supplierGroupApproval", response);
      if (response.status === 200) {
        notification.success({
          message: response.data.status,
          description: response.data.message,
          duration: 3,
        });
        return response;
      } else {
        //Selain Response 200
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const SupplerGroupRequest = createAsyncThunk(
  "supplierGroupSlice/SupplerGroupRequest",
  async (data, { rejectWithValue }) => {
    console.log("SupplerGroupRequest");
    try {
      const response = await SupplierGroupService.SupplerGroupRequest(data);
      console.log("SupplerGroupRequest", response);
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const supplierGroupSliceSlice = createSlice({
  name: "supplierGroupSlice",
  initialState,
  reducers: {
    showLoading: (state) => {
      state.loading = true;
    },
    falseMessage: (state) => {
      state.message = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getSupplerGroup.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSupplerGroup.fulfilled, (state, action) => {
        state.loading = false;
        state.subSupplerGroupList = action.payload.data;
        state.getCount = action.payload.data.count;
      })
      .addCase(getSupplerGroup.rejected, (state, action) => {
        state.loading = false;
        state.response = action.payload;
        state.showMessage = true;
      })

      //Supplier Group serch list
      .addCase(getSupplerGroupItemSerch.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getSupplerGroupItemSerch.fulfilled, (state, action) => {
        console.log(
          "🚀 ~ .addCasegetSupplerGroupItemSerch ~ action:",
          action.payload.data
        );
        state.loading = false;
        state.subSupplerGroupList = action.payload.data;
        state.getCount = action.payload.count;
      })
      .addCase(getSupplerGroupItemSerch.rejected, (state, action) => {
        state.loading = false;
        state.supplierGroupSliceList = action.payload;
      })

      //Supplier Group item list
      .addCase(getSupplerGroupItem.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getSupplerGroupItem.fulfilled, (state, action) => {
        console.log(
          "🚀 ~ .addCasegetSupplerGroupItem ~ action:",
          action.payload.data
        );
        state.loading = false;
        state.subSupplerGroupList = action.payload.data;
        state.getCount = action.payload.count;
      })
      .addCase(getSupplerGroupItem.rejected, (state, action) => {
        state.loading = false;
        state.supplierGroupSliceList = action.payload;
      })
      //Supplier Group approval list
      .addCase(getSupplerGroupApproval.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getSupplerGroupApproval.fulfilled, (state, action) => {
        console.log(
          "🚀 ~ .addCasegetSupplerGroupApproval ~ action:",
          action.payload.data
        );
        state.loading = false;
        state.subSupplerGroupList = action.payload.data;
        state.getCount = action.payload.count;
      })
      .addCase(getSupplerGroupApproval.rejected, (state, action) => {
        state.loading = false;
        state.supplierGroupSliceList = action.payload;
      })
      //post
      .addCase(addSupplierGroup.pending, (state) => {
        state.loading = true;
      })
      .addCase(addSupplierGroup.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = "/";
        state.result = action.payload;
        state.message = "ok";
      })
      .addCase(addSupplierGroup.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //Do Approval
      .addCase(supplierGroupApproval.pending, (state) => {
        state.loading = true;
        state.message = "";
      })
      .addCase(supplierGroupApproval.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = "/";
        state.result = action.payload;
        state.message = "ok";
      })
      .addCase(supplierGroupApproval.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //Do Return
      .addCase(supplierGroupReturn.pending, (state) => {
        state.loading = true;
        state.message = "";
      })
      .addCase(supplierGroupReturn.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = "/";
        state.result = action.payload;
        state.message = "ok";
      })
      .addCase(supplierGroupReturn.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      });
  },
});

export const { showLoading, falseMessage } = supplierGroupSliceSlice.actions;

export default supplierGroupSliceSlice.reducer;
